/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sportdeelname_Api_Errors_Sport_Not_FoundInputs */

const nl_sportdeelname_api_errors_sport_not_found = /** @type {(inputs: Sportdeelname_Api_Errors_Sport_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze sport bestaat niet meer. Ververs de pagina en probeer het opnieuw.`)
};

/**

* @param {Sportdeelname_Api_Errors_Sport_Not_FoundInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const sportdeelname_api_errors_sport_not_found = /** @type {((inputs?: Sportdeelname_Api_Errors_Sport_Not_FoundInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sportdeelname_Api_Errors_Sport_Not_FoundInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_sportdeelname_api_errors_sport_not_found(inputs)
});
export { sportdeelname_api_errors_sport_not_found as "sportdeelname.api_errors.sport_not_found" }